import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-external-link-icon",
  templateUrl: "./external-link-icon.component.html",
  styleUrls: ["./external-link-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  standalone: true,
})
export class ExternalLinkIconComponent {
  public class = input<string>("on-hover-visibility-show");
}
